import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LsFormCheckboxComponent } from './ls-form-checkbox.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule],
  declarations: [LsFormCheckboxComponent],
  exports: [LsFormCheckboxComponent]
})
export class LsFormCheckboxModule {}
